import { useState } from "react";

export interface LawyerInvitation {
  code: string;
  url: string;
}

export function InviteLawyer({ invitation }: { invitation: LawyerInvitation }) {
  const [notice, setNotice] = useState("");
  async function copy() {
    await navigator.clipboard.writeText(invitation.url);
    setNotice("邀请链接已复制");
  }
  async function share() {
    if (navigator.share) {
      await navigator.share({ title: "邀请律师加入中承信合平台", url: invitation.url });
      return;
    }
    await copy();
  }
  return <section className="personal-lawyer-panel personal-invite-panel" aria-label="邀请律师">
    <header><h1>邀请律师</h1><p>将专属注册链接发给其他律师，注册成功后永久建立邀请关系。</p></header>
    <div className="personal-invite-card">
      <span>我的专属邀请码</span><strong>{invitation.code}</strong>
      <label>专属邀请链接<input value={invitation.url} readOnly /></label>
      <div><button type="button" onClick={() => void copy()}>复制邀请链接</button><button className="is-primary" type="button" onClick={() => void share()}>分享邀请链接</button></div>
      {notice && <p role="status">{notice}</p>}
    </div>
    <p className="personal-invite-note">邀请关系以对方通过此链接完成注册为准；已注册账号不会重复绑定或改绑。</p>
  </section>;
}
